import {
    CustomerHorizonIssuesDtoSchema,
    FarmWithHorizonIssuesDtoSchema,
    HorizonVersionFarmsAggregationDtoSchema,
} from "@datamole/lssa-api-schema";

import { apiJS as baseApi } from "@/store/api";

interface GetFarmHorizonIssuesArgs {
    customerNumber: string;
    farmLicenseKey?: string;
}

const api = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getFarmHorizonIssues: builder.query<CustomerHorizonIssuesDtoSchema, GetFarmHorizonIssuesArgs>({
            query: ({ customerNumber, farmLicenseKey }) => ({
                url: `liobs/customers/${customerNumber}/horizon-issues${farmLicenseKey ? `?farmLicenseKey=${farmLicenseKey}` : ""}`,
                method: "GET",
            }),
        }),
        getHorizonVersionAggregation: builder.query<HorizonVersionFarmsAggregationDtoSchema, void>({
            query: () => ({
                url: `liobs/farms/horizon-version`,
            }),
        }),
        getFarmWithHorizonIssues: builder.query<FarmWithHorizonIssuesDtoSchema[], void>({
            query: () => ({
                url: `liobs/farms`,
            }),
        }),
    }),
});

export const { useGetHorizonVersionAggregationQuery, useGetFarmHorizonIssuesQuery, useGetFarmWithHorizonIssuesQuery } =
    api;
